// extracted by mini-css-extract-plugin
export default {"image":"CardBlog_image__QoLn3","divButtons":"CardBlog_divButtons__7Jb3b","txtButtonG":"CardBlog_txtButtonG__Lm9Ok","txtButtonR":"CardBlog_txtButtonR__0aIHn"};